import { combineReducers } from 'redux';
import authSlice from './authSlice';
import screeningSlice from './screeningSlice';
export default combineReducers({
  authReducer: authSlice,
  screeningReducer: screeningSlice
});
